/**
 * ScrollToTop - Scrolls to top on route change
 * Story 12.32: Global scroll-to-top for all page navigations
 *
 * React Router does not scroll to top on navigation by default.
 * This component handles it globally, with an exclusion list for
 * routes that manage their own scroll behavior.
 *
 * @module components/layout/ScrollToTop
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Paths that manage their own scroll behaviour. Listed here so the global
// scroll-to-top does not override them on route entry.
// - /collection: CollectionPage scrolls to #aarrearkku on fresh entry and
//   relies on the browser's native scroll restoration on back-nav
//   (Epic 19 Story 4, tasks 1.5 + 1.6).
const EXCLUDED_PATHS: string[] = ['/collection'];

export function ScrollToTop(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!EXCLUDED_PATHS.some((p) => pathname.startsWith(p))) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
